"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var multisizeVariantOption1 = 'Multi';
var BundleComponents = /** @class */ (function () {
    function BundleComponents(subscription) {
        this.subscription = subscription;
    }
    BundleComponents.prototype.getBundleVariant = function () {
        var _a, _b, _c;
        var subscription = this.subscription.subscription;
        return {
            title: "".concat(this.getBundleType(), " Bundle"),
            quantity: 1,
            isOOS: false,
            isLowStock: false,
            imgSrc: ((_b = (_a = subscription.variant) === null || _a === void 0 ? void 0 : _a.featured_image) === null || _b === void 0 ? void 0 : _b.src) || ((_c = subscription.product) === null || _c === void 0 ? void 0 : _c.images[0].src),
        };
    };
    BundleComponents.prototype.containsOutOfStockItem = function () {
        var _a;
        return this.subscription.children.some(function (c) { return (0, utils_1.isItemOOS)(c); }) || (this.subscription.onetimes ? (_a = this.subscription.onetimes) === null || _a === void 0 ? void 0 : _a.some(function (c) { return (0, utils_1.isItemOOS)(c); }) : false);
    };
    BundleComponents.prototype.getBundleType = function () {
        var subscription = this.subscription.subscription;
        switch (subscription.product_title) {
            case 'Vitamin Bundle':
                return 'Vitamin';
            case 'Training Pants Bundle':
                return 'Training Pant';
            // check for Essentials in case user created a an 'Essentials Bundle' pre-launch
            case 'Essentials Bundle':
            case 'Fundamentals Bundle':
            case 'Essentials Bundle':
                return 'Fundamentals';
            default:
                return 'Diaper';
        }
    };
    BundleComponents.prototype.getComponents = function () {
        var _this = this;
        var _a;
        var _b = this.subscription, children = _b.children, onetimes = _b.onetimes, subscription = _b.subscription;
        var isMultisizeDiaperBundle = ((_a = subscription.variant) === null || _a === void 0 ? void 0 : _a.option1) === multisizeVariantOption1;
        var sortedChildren = __spreadArray([], __read(children), false).sort(this.sortOOSLast);
        var sortedOnetimes = onetimes ? __spreadArray([], __read(onetimes), false).sort(this.sortOOSLast) : [];
        var diaperBundleItems = sortedChildren
            .filter(function (sc) { return sc.product_title.includes('Pattern') || sc.product_title.includes('(Bundle) Wipes'); })
            .map(function (item) {
            var _a, _b;
            var prettyProductType = (function () {
                var _a, _b;
                if (!((_a = item.variant) === null || _a === void 0 ? void 0 : _a.option1))
                    return '';
                var productType = _this.getProductTypeForSize((_b = item.variant) === null || _b === void 0 ? void 0 : _b.option1);
                if (productType === 'TrainingPants')
                    return 'Training Pants';
                return productType;
            })();
            return __assign(__assign({}, _this.commonItemAttrs(item)), { title: item.product_title.includes('Pattern') ? "".concat((_a = item.variant) === null || _a === void 0 ? void 0 : _a.option2, " ").concat(prettyProductType) : item.product_title.split("(Bundle)")[1], optionName: isMultisizeDiaperBundle ? "(Size ".concat((_b = item.variant) === null || _b === void 0 ? void 0 : _b.option1, ")") : '' });
        });
        var vitaminBundleItems = sortedChildren.map(function (item) { return (__assign(__assign({}, _this.commonItemAttrs(item)), { title: item.product_title.split('(Vitamin Bundle)')[1] })); });
        var essentialsBundleItems = sortedChildren.map(function (item) {
            var _a;
            return __assign(__assign({}, _this.commonItemAttrs(item)), { title: item.product_title.replace(/^\(.+?\)/, ''), optionName: (_a = item.variant) === null || _a === void 0 ? void 0 : _a.option1 });
        });
        var extraItems = sortedChildren
            .filter(function (item) { return !item.product_title.includes('Pattern') && !item.product_title.includes('(Bundle) Wipes'); })
            .map(function (item) { return (__assign(__assign({}, _this.commonItemAttrs(item)), { title: item.product_title.split('(Discount)')[1] })); });
        var onetimeItems = (sortedOnetimes || []).map(function (item) {
            var _a;
            return (__assign(__assign({}, _this.commonItemAttrs(item)), { title: ((_a = item.product) === null || _a === void 0 ? void 0 : _a.title.replace('(Bundle)', '').replace('(Discount)', '')) || '', price: item.price, id: item.id }));
        });
        return { diaperBundleItems: diaperBundleItems, vitaminBundleItems: vitaminBundleItems, essentialsBundleItems: essentialsBundleItems, extraItems: extraItems, onetimeItems: onetimeItems };
    };
    BundleComponents.prototype.commonItemAttrs = function (item) {
        var _a, _b, _c, _d, _e, _f;
        return {
            imgSrc: ((_b = (_a = item.variant) === null || _a === void 0 ? void 0 : _a.featured_image) === null || _b === void 0 ? void 0 : _b.src) || ((_e = (_d = (_c = item.product) === null || _c === void 0 ? void 0 : _c.images) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.src),
            quantity: item.quantity,
            optionName: (_f = item.variant) === null || _f === void 0 ? void 0 : _f.option1,
            isOOS: (0, utils_1.isItemOOS)(item),
            isLowStock: (0, utils_1.isVariantLowStock)(item.variant),
        };
    };
    BundleComponents.prototype.sortOOSLast = function (a, b) {
        if ((0, utils_1.isItemOOS)(a) && !(0, utils_1.isItemOOS)(b))
            return 1;
        if ((0, utils_1.isItemOOS)(b) && !(0, utils_1.isItemOOS)(a))
            return -1;
        if ((0, utils_1.isVariantLowStock)(a.variant) && !(0, utils_1.isVariantLowStock)(b.variant))
            return 1;
        if ((0, utils_1.isVariantLowStock)(b.variant) && !(0, utils_1.isVariantLowStock)(a.variant))
            return -1;
        return 0;
    };
    BundleComponents.prototype.getProductTypeForSize = function (size) {
        if (['12-24M', '2T-3T', '3T-4T', '4T-5T'].includes(size))
            return 'TrainingPants';
        return 'Diapers';
    };
    return BundleComponents;
}());
exports.default = BundleComponents;
